import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import {
  ChevronIcon2
} from './SVGIcons';

import Social from './Social'
import OffcanvasForm from './OffcanvasForm';
import MadeInRussia from './MadeInRussia';

class Window extends Component {
  state = {
    showForm: false
  };

  componentDidMount() {
    // Блокировка прокрутки body при открытии
    if (this.props.show) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(prevProps) {
    // Блокировка/разблокировка прокрутки при изменении состояния
    if (this.props.show !== prevProps.show) {
      document.body.style.overflow = this.props.show ? 'hidden' : 'unset';
    }
  }

  componentWillUnmount() {
    // Возвращаем прокрутку при размонтировании
    document.body.style.overflow = 'unset';
  }

  handleBackdropClick = (e) => {
    // Закрываем только при клике на backdrop, не на содержимое
    if (e.target === e.currentTarget && this.props.onHide) {
      this.props.onHide();
    }
  };

  // Метод для открытия формы
  openForm = () => {
    this.setState({ showForm: true });
  };

  // Метод для закрытия формы
  closeForm = () => {
    this.setState({ showForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем модальное окно Window
    if (this.props.onHide) {
      this.props.onHide();
    }
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {
    const { show, onHide, className = '', data } = this.props;
    const { showForm } = this.state;

    if (!show) return null;

    return (
      <>
        {/* Затемнение фона (backdrop) */}
        <div 
          className="fixed inset-0 bg-black/50 z-50 transition-opacity duration-300"
          style={{
            animation: 'fadeIn 0.3s ease-out'
          }}
          onClick={this.handleBackdropClick}
        >
          {/* Контейнер для центрирования */}
          <div className="flex items-center justify-center min-h-full p-2.5">
            {/* Модальное окно */}
            <div 
              className={`
                relative bg-white rounded-[15px] w-full max-w-[559px] 
                shadow-xl transition-all duration-300
                ${className}
              `}
              style={{
                animation: 'slideIn 0.3s ease-out'
              }}
            >
              {/* Кнопка закрытия */}
              <button
                onClick={onHide}
                className="absolute top-3 right-3 z-10 p-2 hover:opacity-70 transition-opacity"
                aria-label="Закрыть"
              >
                <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 0.5L8.5 8.5" stroke="black" strokeLinecap="round"/>
                  <path d="M8.5 0.5L0.5 8.5" stroke="black" strokeLinecap="round"/>
                </svg>
              </button>

              <div className='w-full flex flex-col sm:flex-row items-start justify-between px-[20px] py-[30px] leading-none tracking-[-0.04em]'>
                <div className='flex-1'>
                  <div className='w-full items-center flex justify-center sm:justify-start'>
                    <div className='h-[38px] bg-[#F5F7F9] rounded-full px-[15px] inline-flex items-center gap-[9px]'>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1.49951H6C3 1.49951 1.5 2.99951 1.5 5.99951V15.7495C1.5 16.162 1.8375 16.4995 2.25 16.4995H12C15 16.4995 16.5 14.9995 16.5 11.9995V5.99951C16.5 2.99951 15 1.49951 12 1.49951Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.68454 5.87963L5.79204 9.77212C5.64204 9.92212 5.49955 10.2146 5.46955 10.4246L5.25955 11.9096C5.18455 12.4496 5.55954 12.8246 6.09954 12.7496L7.58453 12.5396C7.79453 12.5096 8.08705 12.3671 8.23705 12.2171L12.1295 8.32462C12.797 7.65712 13.1196 6.87712 12.1295 5.88712C11.1395 4.88962 10.3595 5.20463 9.68454 5.87963Z" stroke="#032432" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.12891 6.43408C9.45891 7.61158 10.3814 8.54158 11.5664 8.87158" stroke="#032432" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <div className='text-[#032432]/60 text-[14px]'>Обратная связь</div>
                    </div>
                  </div>
                  <div className='mt-[15px] text-[#032432] text-[24px] sm:text-[32px] text-center sm:text-start'>Мы всегда на связи <span className='text-[#032432]/60'>в мессенджерах!</span></div>
                  <div className='mt-[10px] text-black/60 text-[12px] sm:text-[14px] text-center sm:text-start'>Напишите или позвоните для консультации</div>
                  <div className='hidden sm:flex flex-col items-start gap-[15px] mt-[73px]'>
                    <img src={data?.mlogo} alt="химавангард" width={204} height={53} />
                    {/* Знак «Сделано в России» — рядом с логотипом */}
                    <MadeInRussia variant='horizontal' className='w-[204px] max-w-full' imgClassName='w-full' />
                  </div>
                  <div className='hidden sm:flex items-center gap-[5px] mt-[9px]'>
                    {/* Кнопка Оставить заявку с открытием формы */}
                    <div 
                      className='flex items-center gap-[9px] h-[40px] px-[35px] bg-[#009EE3] text-white rounded-full cursor-pointer hover:bg-[#0082c0] transition-colors duration-300'
                      onClick={this.openForm}
                    >
                      <div className='text-[14px] xl:text-[16px]'>Оставить заявку</div>
                      <ChevronIcon2 stroke="white" />
                    </div>
                    <Social social={data?.social || []} width={40} />
                  </div>
                </div>
                <div className='flex-none mx-auto sm:mx-0'>
                  <div className='w-[175px] h-[175px] sm:w-[203px] sm:h-[203px] bg-[#F5F7F9] rounded-[15px] flex items-center justify-center'>
                    <img src={data?.qr} alt="qr" width={179} height={179} className='w-[154px] h-[154px] sm:w-[179px] sm:h-[179px]' />
                  </div>
                  <div className='w-[175px] sm:w-[203px] bg-[#F5F7F9] rounded-[15px] p-[15px]'>
                    <div className='text-[#032432] text-[16px] sm:text-[18px]'>Хотите позвонить?</div>
                    <div className='mt-[2px] text-[12px] sm:text-[14px] text-black/60'>Нажмите для звонка</div>
                    <a href={`tel:${data?.phone?.replace(/[-()\s]/g, '')}`} className='block mt-[13px] text-[#009EE3] text-[16px] sm:text-[22px]'>{data?.phone}</a>
                  </div>
                </div>
                <div className='sm:hidden mt-[15px] flex flex-col items-center gap-[10px] w-full'>
                  <img src={data?.mlogo} alt="химавангард" width={204} height={53} />
                  <MadeInRussia variant='horizontal' className='w-[204px] max-w-full' imgClassName='w-full' />
                </div>
                <div className='flex sm:hidden items-center justify-center gap-[5px] mt-[5px] w-full'>
                  {/* Кнопка Оставить заявку для мобильной версии */}
                  <div 
                    className='flex items-center gap-[9px] h-[40px] px-[35px] bg-[#009EE3] text-white rounded-full cursor-pointer hover:bg-[#0082c0] transition-colors duration-300'
                    onClick={this.openForm}
                  >
                    <div className='text-[14px] xl:text-[16px]'>Оставить заявку</div>
                    <ChevronIcon2 stroke="white" />
                  </div>
                  <Social social={data?.social || []} width={40} />
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Форма обратной связи */}
        <OffcanvasForm
          show={showForm}
          hide={this.closeForm}
          formTitle="Оставить заявку"
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />

        {/* Стили для анимаций */}
        <Helmet>
          <style>{`
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: scale(0.95) translateY(-10px);
            }
            to {
              opacity: 1;
              transform: scale(1) translateY(0);
            }
          }
        `}</style>
        </Helmet>
      </>
    );
  }
}

export default Window;